function popUp(timer){
    let pop_modal_container = document.querySelector('.fixed-container-popup');
    
    setTimeout(() => {
                pop_modal_container.dataset.popup_show="true";
    }, timer*1000);
    
    let btn_cerrar = document.querySelector('#close');
    let text_cerrar_popup = document.querySelector('#text-cerrar-popup');
    btn_cerrar.addEventListener("click", () => {
        pop_modal_container.dataset.popup_show="false";
        pop_modal_container.remove();
    })
    text_cerrar_popup.addEventListener("click", () => {
        pop_modal_container.dataset.popup_show="false";
        pop_modal_container.remove();
    })
    }

    function displayImageBasedOnTime(time1, time2, imgSrc1, imgSrc2) {
        let popUpTag = tags_shopify;
        const currentTime = new Date();
        const time1Date = new Date(currentTime.toDateString() + ' ' + time1);
        const time2Date = new Date(currentTime.toDateString() + ' ' + time2);
    
        let popUp1Shown = localStorage.getItem("popUp1ShownAbril") === 'true';
        let popUp2Shown = localStorage.getItem("popUp2ShownAbril") === 'true';
    
        // Verificar si la hora actual está en el rango de 08:00 a 18:00
        if (currentTime >= time1Date && currentTime < time2Date) {
            // Si aún no se ha mostrado el pop-up 1 y estamos en el rango de tiempo
            if (!popUp1Shown) {
                showPopUp(1, imgSrc1);
                popUpTag.value = popUpTag.value + ",pop_up_home2";
                localStorage.setItem("popUp1ShownAbril", 'true');
            }
        } else {    
            // Si estamos fuera del rango de 08:00 a 18:00 y aún no se ha mostrado el pop-up 2
            if (!popUp2Shown) {
                popUpTag.value = popUpTag.value + ",pop_up_home1";
                showPopUp(2, imgSrc2);
                localStorage.setItem("popUp2ShownAbril", 'true');
            }
        }
    }
    
    function showPopUp(pop, imgSrc) {
        document.getElementById("image_pop_up_container").src = imgSrc;
        popUp(12);
    }
    

    



